import * as swcHelpers from '@swc/helpers';
import { okOrThrow } from '../response.js';
import { acceptJson } from '../shared.js';

const unlink = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apiUrl, request) {
        const { orderNumber , orderToken  } = request;
        const response = yield fetch(`${apiUrl}/orders/${orderNumber}/customer?orderDataToken=${orderToken}`, {
            method: 'DELETE',
            headers: swcHelpers.objectSpread({}, acceptJson)
        });
        okOrThrow(response);
        return response;
    });
    return function unlink(apiUrl, request) {
        return _ref.apply(this, arguments);
    };
}();

export { unlink };
//# sourceMappingURL=unlink.js.map
